function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.424 20.571l.684-.684a1.5 1.5 0 00.39-1.442L19.065 9.2l3.217-3.217a3.109 3.109 0 00.441-3.97 3 3 0 00-4.57-.386l-3.33 3.331L5.58 2.526a1.5 1.5 0 00-1.443.39l-.684.684a1.5 1.5 0 00.289 2.347l6.308 3.785-4.8 5.44-1.5.022a1.5 1.5 0 00-1.282.387L.97 16.953a.749.749 0 00.235 1.219L4.1 19.805 6 22.8a.751.751 0 001.22.235l1.309-1.248a1.5 1.5 0 00.447-1.36L9 18.922l5.292-4.948 3.785 6.308a1.5 1.5 0 002.347.289z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgPlaneTrip1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref);
}

export default SvgPlaneTrip1;